import React, { useMemo } from "react";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import { getLatestDateFromData } from "../../../Utils/utils";
import Loader from "../../../components/Loader";

const RtiPage = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();

  const { data: rtiData = [], isLoading: rtiDataIsLoading } =
    useGetProtectedApiDataQuery({
      url: "rti-new",
      lang: languageType,
    });

  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(rtiData);
  }, [rtiData]);

  if (rtiDataIsLoading) {
    return <Loader />;
  }
  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="/images/inner_aboutbann.jpg"
        title={getText("RTI", "आरटीआई")}
        titleLink="/rti"
        isActive={getText("RTI", "आरटीआई")}
      />
      <div className="inner-container">
        <div className="container">
          <section className="ourCompany mb-4">
            <div className="accordion" id="accordionExample">
              <strong>
                <h4 className="title4">{rtiData[0].nothing}</h4>
              </strong>
              {rtiData.map((rti, index) => {
                const uniqueId = `collapse-${index + 100}`; // Unique ID for each collapse section
                return (
                  <div className="accordion-item" key={index}>
                    <div
                      className="rti-acc"
                      id={`heading-${index}`}
                      data-bs-toggle="collapse"
                      data-bs-target={`#${uniqueId}`}
                      aria-expanded="false"
                      aria-controls={uniqueId}
                      style={{ cursor: "pointer" }}
                    >
                      <h2 className="mb-0">
                        <div
                          dangerouslySetInnerHTML={{ __html: rti.title }}
                        ></div>
                      </h2>
                      <button
                        className="btn btn-link btn-sm toggle-btn"
                        // type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#${uniqueId}`}
                        aria-expanded="false"
                        aria-controls={uniqueId}
                      >
                        {/* <i className="fas fa-plus"></i> */}
                      </button>
                    </div>

                    <div
                      id={uniqueId}
                      className="accordion-collapse collapse"
                      aria-labelledby={`heading-${index}`}
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <div
                          dangerouslySetInnerHTML={{ __html: rti.body }}
                        ></div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>
          <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
        </div>
      </div>
    </>
  );
};

export default RtiPage;
